import OptimizedLink from "../../Atoms/OptimizedLink";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import {
  HiUserGroup,
  IoLibrary,
  MdTour,
  MdQuestionAnswer as QuestionsIcon,
} from "../../Atoms/AppIcons";
import { locationIds } from "../../../core/enums";
import CustomTourBanner from "../../Cards/CustomTourBanner";
import EbookBanner from "../../Cards/EbookForm/EbookBanner";
import AcceptedPayments from "./AcceptedPayments";
import styles from "./Footer.module.css";
import FooterNavigation from "./FooterNavigation";
import FooterTA from "./FooterTA";
import FooterTourList from "./FooterTourList";
import PartnerList from "./Partner";

export default function Footer() {
  const router = useRouter();
  const [location, setLocation] = useState(locationIds.JAPAN);
  const isCheckout =
    router.pathname === "/bookings/[id]" ||
    router.pathname === "/checkout/[id]" ||
    router.pathname === "/payments/[id]"
      ? true
      : false;

  const hideFooter =
    isCheckout ||
    router.pathname === "/guide/[guideId]/sign-contracts" ||
    router.pathname === "/guide/sign-contracts-success" ||
    router.pathname === "/bookings/[id]/chat" ||
    router.pathname === "/performance-test" ||
    (router.asPath.startsWith("/performance-test") &&
      router.asPath !== "/performance-test/footer");

  useEffect(() => {
    if (router) {
      const el = window?.document?.querySelector(
        '[aria-label="breadcrumbs"]',
      ) as HTMLElement | null;
      const text = el?.innerText || "";

      if (router.query?.country === "thailand" || text.includes("Thailand")) {
        setLocation(locationIds.BANGKOK);
      } else {
        setLocation(locationIds.JAPAN);
      }
    }
  }, [router]);

  return (
    !hideFooter && (
      <section style={hideFooter ? { display: "none" } : null}>
        <div className="AppLayout">
          {location === locationIds.BANGKOK ? (
            <CustomTourBanner from={locationIds.BANGKOK} />
          ) : (
            <CustomTourBanner from={"footer"} />
          )}
        </div>
        <FooterTA />
        {location !== locationIds.BANGKOK && <EbookBanner />}

        <FooterNavigation />
        <FooterTourList />

        <footer>
          <div className={styles.AppFooter}>
            <div
              className={styles.AppFooterInner}
              style={{
                background: "linear-gradient(90deg, #f44336, #e91e63)",
              }}
            >
              <div className={styles.footAbout}>
                <h6>MagicalTrip Inc.</h6>

                <ul>
                  <li>
                    <OptimizedLink
                      href="/terms-of-service"
                      className={styles.AppFooterTextLink}
                      prefetchMode="disable"
                    >
                      Terms of Service
                    </OptimizedLink>
                  </li>
                  <li>
                    <OptimizedLink
                      href="/privacy-policy"
                      className={styles.AppFooterTextLink}
                      prefetchMode="disable"
                    >
                      Privacy Policy
                    </OptimizedLink>
                  </li>
                  <li>
                    <OptimizedLink
                      className={styles.AppFooterTextLink}
                      href="/external-transmission-rule"
                      prefetchMode="disable"
                    >
                      External Transmission Rule
                    </OptimizedLink>
                  </li>

                  <li>
                    <OptimizedLink
                      href="/Standard_General_Conditions_of_Travel_Agency_Business.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textAlign: "left" }}
                      prefetchMode="disable"
                    >
                      Sign (Registration Form) & Standard General Conditions of
                      Travel Agency Business
                    </OptimizedLink>
                  </li>
                </ul>
              </div>
              <div className={styles.AppFooterColumns}>
                <div className={styles.AppFooterCol}>
                  <div>
                    <h6 className={styles.FooterHeading}>About MagicalTrip</h6>
                    <ul>
                      <li>
                        <OptimizedLink
                          href="/about-us?ref=footer"
                          target="_blank"
                          rel="noopener noreferrer"
                          prefetchMode="disable"
                        >
                          <span>About Us</span>
                        </OptimizedLink>
                      </li>
                      <li
                        style={{
                          position: "relative",
                        }}
                      >
                        <OptimizedLink
                          href="/media?ref=footer"
                          target="_blank"
                          rel="noopener noreferrer"
                          prefetchMode="disable"
                        >
                          <span>Our Blog</span>
                        </OptimizedLink>
                      </li>
                    </ul>
                    <h6
                      className={styles.FooterHeading}
                      style={{ marginTop: 30 }}
                    >
                      Work With Us
                    </h6>
                    <ul>
                      <li>
                        <OptimizedLink
                          href="/recruit?ref=footer"
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.AppFooterTextLink}
                          prefetchMode="disable"
                        >
                          Become a MagicalTrip Guide
                        </OptimizedLink>
                      </li>
                      <li>
                        <OptimizedLink
                          href="/business-partners?ref=footer"
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.AppFooterTextLink}
                          prefetchMode="disable"
                        >
                          As a Travel Agency
                        </OptimizedLink>
                      </li>
                      <li>
                        <OptimizedLink
                          href="/business-partners?ref=footer"
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.AppFooterTextLink}
                          prefetchMode="disable"
                        >
                          As a Content Creator
                        </OptimizedLink>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className={styles.AppFooterCol}>
                  <h6 className={styles.FooterHeading}>Support</h6>
                  <ul>
                    <li className={styles.FooterIconLink}>
                      <OptimizedLink href="/contact-us" prefetchMode="disable">
                        <span className={styles.FooterIconLinkIcon}>
                          <QuestionsIcon color={"#fff"} size={24} />
                        </span>
                        <span>Contact Us</span>
                      </OptimizedLink>
                    </li>
                    <li className={styles.FooterIconLink}>
                      <OptimizedLink
                        href="/big-group-tours?ref=footer"
                        prefetchMode="disable"
                      >
                        <span className={styles.FooterIconLinkIcon}>
                          <HiUserGroup color={"#fff"} size={24} />
                        </span>
                        <span>Booking for Big Groups</span>
                      </OptimizedLink>
                    </li>
                    <li className={styles.FooterIconLink}>
                      <OptimizedLink
                        href="/custom-tour/japan?ref=footer-support"
                        prefetchMode="disable"
                      >
                        <span className={styles.FooterIconLinkIcon}>
                          <MdTour color={"#fff"} size={24} />
                        </span>
                        <span>Japan Custom Tour Service</span>
                      </OptimizedLink>
                    </li>
                    <li className={styles.FooterIconLink}>
                      <OptimizedLink
                        href="/custom-tour/thailand?ref=footer-support"
                        prefetchMode="disable"
                      >
                        <span className={styles.FooterIconLinkIcon}>
                          <MdTour color={"#fff"} size={24} />
                        </span>
                        <span>Thailand Custom Tour Service</span>
                      </OptimizedLink>
                    </li>

                    <li className={styles.FooterIconLink}>
                      <OptimizedLink
                        href="/faq?ref=footer"
                        prefetchMode="disable"
                      >
                        <span className={styles.FooterIconLinkIcon}>
                          <IoLibrary color={"#fff"} size={24} />
                        </span>
                        <span>Frequently Asked Questions</span>
                      </OptimizedLink>
                    </li>
                  </ul>
                </div>

                <div className={styles.AppFooterCol}>
                  <h6 className={styles.FooterHeading}>As Featured On</h6>
                  <PartnerList />
                  <h6 className={styles.FooterHeading}>Ways You Can Pay</h6>
                  <AcceptedPayments />
                  <ul>
                    <li className={styles.ContactAddress}>
                      <p>
                        Certified Travel Licenses: <br />
                        Tokyo Metropolitan Government Office: No.2-7941 <br />
                        Thailand TAT Travel License: No.14/04706
                        <br />
                        <br />
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className={styles.BottomFooter}>
              <div className="AppLayout">
                <div
                  className={styles.AppFooterInner}
                  style={{
                    display: "flex",
                    padding: 0,
                  }}
                >
                  <div className={styles.AppFooterCopyright}>
                    <small>
                      © {new Date().getFullYear()} MagicalTrip™ /
                      マジカルトリップ™
                    </small>
                  </div>

                  <ul className={styles.AppFooterNav}>
                    <li className={styles.AppFooterTap}>
                      <OptimizedLink
                        href="/terms-of-service"
                        prefetchMode="disable"
                      >
                        Terms of Service
                      </OptimizedLink>
                    </li>
                    <li className={styles.AppFooterTap}>
                      <OptimizedLink
                        href="/privacy-policy"
                        prefetchMode="disable"
                      >
                        Privacy Policy
                      </OptimizedLink>
                    </li>
                    <li className={styles.AppFooterTap}>
                      <OptimizedLink
                        href="/external-transmission-rule"
                        prefetchMode="disable"
                      >
                        External Transmission Rule
                      </OptimizedLink>
                    </li>
                    <li className={styles.AppFooterTap}>
                      <OptimizedLink
                        href="/Standard_General_Conditions_of_Travel_Agency_Business.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textAlign: "left" }}
                        prefetchMode="disable"
                      >
                        Sign (Registration Form) & Standard General Conditions
                        of <br />
                        Travel Agency Business
                      </OptimizedLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </section>
    )
  );
}
